export default class Note {
  static get toolbox() {
    return {
      title: "Warning",
      icon: `<i class="fad fa-lightbulb-exclamation"></i>`,
    };
  }

  constructor({ data }) {
    if (data) this.data = data;
  }

  render() {

    // w1: content
    // w2: subtitle
    // w3: title

    let wrapper = document.createElement("div");
    wrapper.classList.add("proEditorWrapper");
    let w1 = document.createElement("p");
    w1.classList.add("w1");
    w1.contentEditable = true;
    let w2 = document.createElement("p");
    w2.classList.add("w2");
    w2.contentEditable = true;
    let w3 = document.createElement("p");
    w3.classList.add("w3");
    w3.innerText = "WARNING!";
    w3.contentEditable = true;

    if (this.data.subtitle) w2.innerHTML = this.data.subtitle;
    if (this.data.content) w1.innerHTML = this.data.content;
    if (this.data.title) w3.innerHTML = this.data.title;

    wrapper.appendChild(w3);
    wrapper.appendChild(w2);
    wrapper.appendChild(w1);
    return wrapper;
  }

  save(blockContent) {
    let content = blockContent.querySelector('.w1').innerHTML;
    let subtitle = blockContent.querySelector('.w2').innerHTML;
    let title = blockContent.querySelector('.w3').innerHTML;
    return {
      content,
      subtitle,
      title
    };
  }

  static get sanitize() {
    return {
      a: true,
      i: true,
      b: true,
    };
  }
}